'use client'

import { useRef } from 'react'
import Link from 'next/link'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import SafeImage from './SafeImage'
import { blogCards } from '@/data/homepage'

export default function BlogSection() {
  const scrollerRef = useRef<HTMLDivElement>(null)

  const scrollBy = (amount: number) => {
    scrollerRef.current?.scrollBy({ left: amount, behavior: 'smooth' })
  }

  return (
    <section className="py-10 md:py-12 bg-white">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-6 gap-4">
          <div>
            <div className="text-[#b45309] font-semibold text-[11px] md:text-xs uppercase tracking-wider mb-1">
              FAYDALI BİLGİLER
            </div>
            <h2
              className="text-2xl md:text-3xl font-bold"
              style={{
                background: 'linear-gradient(to top right, #014b64, #01124d)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            >
              BİLGİ BANKASI
            </h2>
          </div>
          <div className="flex gap-2">
            <button
              type="button"
              aria-label="Sola kaydır"
              onClick={() => scrollBy(-280)}
              className="w-11 h-11 bg-[#c2410c] rounded-full text-white hover:bg-[#9a3412] flex items-center justify-center"
            >
              <ChevronLeft size={20} />
            </button>
            <button
              type="button"
              aria-label="Sağa kaydır"
              onClick={() => scrollBy(280)}
              className="w-11 h-11 bg-[#c2410c] rounded-full text-white hover:bg-[#9a3412] flex items-center justify-center"
            >
              <ChevronRight size={20} />
            </button>
          </div>
        </div>

        <div
          ref={scrollerRef}
          className="flex gap-3.5 overflow-x-auto scrollbar-hide"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {blogCards.map((card) => (
            <Link
              key={card.href}
              href={card.href}
              className="group w-[240px] md:w-[260px] flex-shrink-0 rounded-lg shadow hover:shadow-lg border border-gray-100 overflow-hidden bg-white"
            >
              <div className="relative h-[130px] md:h-[140px] overflow-hidden">
                <SafeImage
                  src={card.image}
                  alt={card.title}
                  fill
                  sizes="260px"
                  className="object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-3.5">
                <h3 className="font-semibold text-sm text-[#232f3e] group-hover:text-[#b45309] line-clamp-2 mb-1.5 leading-snug">
                  {card.title}
                </h3>
                <p className="text-[#4b5563] text-xs line-clamp-2 mb-2 leading-relaxed">
                  {card.excerpt}
                </p>
                <span className="text-[#b45309] font-medium text-xs">Devamını Oku</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  )
}
